// extracted by mini-css-extract-plugin
export default {"loaderContainer":"GameLauncher_loaderContainer--_HW","errorWrapper":"GameLauncher_errorWrapper--urG"};